import { render, staticRenderFns } from "./FormRepeaterBasic.vue?vue&type=template&id=2d461cf2&scoped=true&"
import script from "./FormRepeaterBasic.vue?vue&type=script&lang=js&"
export * from "./FormRepeaterBasic.vue?vue&type=script&lang=js&"
import style0 from "./FormRepeaterBasic.vue?vue&type=style&index=0&id=2d461cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d461cf2",
  null
  
)

export default component.exports